/**
 * SEO Configuration
 * Single source of truth for site metadata
 */

export const seoConfig = {
	siteName: "m8tes.ai",
	siteDescription:
		"Deploy autonomous AI teammates to automate recurring tasks—reports, research, and real actions—without hiring.",
	defaultTitle: "m8tes - AI Teammates That Take Action",
	titleTemplate: "%s | m8tes.ai",
	siteUrl: getSiteUrl(),
	twitterHandle: "@m8tes_ai",
	defaultOgImage: "/og-default.png",
	defaultRobots: "index, follow",
} as const;

/**
 * Get site URL based on environment
 * Ensures canonical URLs work across dev/staging/prod
 */
export function getSiteUrl(): string {
	// In production, use env var or hardcoded domain
	if (import.meta.env.PROD) {
		return import.meta.env.VITE_SITE_URL || "https://m8tes.ai";
	}

	// In development, use local URL
	if (typeof window !== "undefined") {
		return window.location.origin;
	}

	// SSR fallback
	return "http://localhost:3000";
}

/**
 * Format title with template
 */
export function formatTitle(pageTitle?: string): string {
	if (!pageTitle) {
		return seoConfig.defaultTitle;
	}
	return seoConfig.titleTemplate.replace("%s", pageTitle);
}
